export default __webpack_public_path__ + "static/media/gallery_12.430bc562.jpg";